import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import type { Maybe } from '@/lib/types';

import { visibilityControl } from '../../Card.styles';

export const Wrapper = styled(Flex)<{
  $type: Maybe<string>;
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
  backgroundColor: Maybe<string>;
}>`
  position: relative;
  overflow: hidden;
  flex-direction: column;
  ${({ backgroundColor }) => css`
    background-color: ${backgroundColor};
  `}
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  ${({ $type }) =>
    $type === 'SquadCard' &&
    css`
      height: 100%;
    `}
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;
export const MediaWrapper = styled(Box)<{
  mediaAnimationEffect: Maybe<string>;
}>`
  width: 100%;

  height: auto;
  aspect-ratio: 0.8;

  overflow: hidden;

  ${({ mediaAnimationEffect, theme }) => css`
    margin-bottom: ${theme.spacing(2)};
    ${mediaAnimationEffect &&
    css`
      &:hover {
        cursor: pointer;
        img {
          transform: scale(1.1);
          transition: all 0.5s linear;
        }
      }
    `}
  `};
`;

export const Text = styled.div<{
  color: Maybe<string>;
  textAlign: Maybe<string>;
}>`
  ${({ color, textAlign, theme }) => css`
    text-align: ${textAlign};
    color: ${color};
    margin-top: ${theme.spacing(1)};
    font-size: ${theme.fontSizes.p2};
    font-weight: 400;
    line-height: 22px;
  `}
`;

export const Media = styled(Box)<{
  $aspectRatio?: { x: number; y: number };
  $backgroundAlignment: Maybe<string>;
}>`
  inset: 0;
  object-fit: cover;
  background-position: center;
  width: 100%;
  height: auto;
  ${({ $aspectRatio }) =>
    $aspectRatio &&
    css`
      aspect-ratio: ${$aspectRatio.x} / ${$aspectRatio.y};
    `};

  ${({ $backgroundAlignment, theme }) => css`
    ${theme.media.md.down} {
      object-position: ${$backgroundAlignment || 'center'};
    }
  `}
`;
